import { IEventBusEmitData, IEventBusListenerData, IEventBusPlugin } from '../core/types';

interface ConsoleLoggerConfig {
  logListeners: boolean;
  logEmits: boolean;
}

export class ConsoleLoggerPlugin implements IEventBusPlugin {
  id = 'console-logger';
  name = 'Console Logger';
  enabled = true;

  private config: ConsoleLoggerConfig = {
    logListeners: false,
    logEmits: false
  };

  constructor(config?: Partial<ConsoleLoggerConfig>) {
    this.config = { ...this.config, ...config };
  }

  onListenerAttached(data: IEventBusListenerData): void {
    if (!this.config.logListeners) return;

    console.groupCollapsed(`[EventBus] Listener Attached ${data.eventName} 👂`);
    console.table(data);
    console.groupEnd();
  }

  onListenerDetached(data: IEventBusListenerData): void {
    if (!this.config.logListeners) return;

    console.groupCollapsed(`[EventBus] Listener Detached ${data.eventName} 🔕`);
    console.table(data);
    console.groupEnd();
  }

  onEventEmitted(data: IEventBusEmitData): void {
    if (!this.config.logEmits) return;

    console.groupCollapsed(`[EventBus] Event Emitted ${data.eventName} 📢`);
    console.table(data);
    console.groupEnd();
  }
}
